import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useStores, ISelectorOption } from '@trivie/core'
import { Dialog } from '@trivie/ui-web/components/dialogs/dialog/dialog'
import { AutocompleteSelector } from '../../../../components/autocomplete-selector'

export const AddUsersToAssignment = observer((props: any) => {
  const { open, onClose, assignmentIDs } = props
  const { assignmentStore } = useStores()
  const { addUsersToAssignment } = assignmentStore

  const [selectedOptions, setSelectedOptions] = useState<ISelectorOption[]>([])

  const handleSelectionChange = (selected: ISelectorOption[]) => {
    setSelectedOptions(selected)
  }

  const addToAssignment = () => {
    const userIds = selectedOptions.map((user) => user.id)
    for (let i = 0; i < assignmentIDs.length; i++) {
      addUsersToAssignment(userIds, assignmentIDs[i])
    }
    onClose()
  }

  const cancel = () => {
    setSelectedOptions([])
    onClose()
  }

  return (
    <Dialog
      onClose={onClose}
      title="Add Users to Assignment"
      aria-labelledby="add users to assignment"
      open={open}
      onConfirm={addToAssignment}
      onCancel={cancel}
      confirmBtnLabel="Add Users"
      disableConfirm={!selectedOptions.length}
      maxWidth="md"
      sx={{
        '& .MuiDialogContent-root': {
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'hidden',
          transition: 'all 0.5s ease-in-out',
          height: 500,
        }}
      >
        <AutocompleteSelector
          variant="users"
          open
          placeholder="Search Users"
          onSelectionChange={handleSelectionChange}
          style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
        />
      </div>
    </Dialog>
  )
})
